/**
 * @param  {HTMLElement} element Element with text to meassure
 * @return {void}
 */
function getTextLength(element) {
  return element.innerText.trim().length;
}

/**
 * @param  {HTMLElement} element Element to truncate
 * @param  {Number} threshold where to cut the text
 * @param  {String} method the method to determine where to cut of the text
 * @return {void}
 */
function truncate(element, threshold, method = 'precise') {
  const container = element;
  const text = element.innerHTML;

  if (method === 'precise') {
    const visibleString = `${text.substring(0, threshold)}&hellip;`;
    const hiddenString = `<span class="hide is-truncated">${text.substring(threshold, element.length)}</span>`;

    container.innerHTML = visibleString + hiddenString;
  }

  if (container.id === undefined) {
    window.console.warn('Please provide an ID on the container to toggle truncated text.');
  }
}

/**
 * @param  {Number} iterator the childs index
 * @param  {Array} children the array from which to hide specific elements
 * @return {void}
 */
function hideFollowingChildren(iterator, children) {
  for (let index = iterator + 1; index < children.length; index += 1) {
    children[index].classList.add('hide');
  }
}

/**
 * @param  {HTMLElement} container the container in which to truncate the text
 * @return {void}
 */
function checkTruncation(container) {
  const children = [].slice.call(container.children);
  const characterThreshold = container.dataset.truncateText;
  const toggler = document.querySelector(`[data-truncate-toggle="${container.id}"]`);

  // has children?
  if (children.length > 0) {
    let childIterator = 0;
    let totalCharacterCount = 0;

    while (totalCharacterCount < characterThreshold) {
      const child = children[childIterator];
      const characterCount = getTextLength(child);

      // add current count to running counter
      totalCharacterCount += characterCount;

      // check if the current child adds more characters than the threshold allows
      if (totalCharacterCount + characterCount >= characterThreshold) {
        truncate(child, characterCount - (totalCharacterCount - characterThreshold));
        hideFollowingChildren(childIterator, children);

        return false;
      }

      if (childIterator === children.length - 1) {
        // remove toggle
        if (toggler) toggler.parentNode.removeChild(toggler);

        return false;
      }

      // bump up the interator
      childIterator += 1;
    }
  } else {
    const characterCount = getTextLength(container);
    if (characterCount > characterThreshold) {
      truncate(container, characterThreshold);
    } else if (toggler) {
      // remove toggle
      toggler.parentNode.removeChild(toggler);
    }
  }

  return true;
}

/**
 * @param  {HTMLElement} container the container in which to revert the checkTruncation
 * @return {void}
 */
function revertcheckTruncation(container) {
  const hiddenElements = [].slice.call(container.querySelectorAll('.hide'));
  const truncatedString = container.querySelector('.is-truncated');

  // show all hidden elements
  hiddenElements.forEach((element) => {
    element.classList.remove('hide');
  });

  // remove hellip
  truncatedString.parentNode.innerText =
    truncatedString.parentNode.innerText.replace('…', '');
}

/**
 * init
 *
 * @param  {HTMLElement} scope = document
 * @return {void}
 */
export default function init(scope = document) {
  const containers = [].slice.call(scope.querySelectorAll('[data-truncate-text]'));
  const togglers = [].slice.call(scope.querySelectorAll('[data-truncate-toggle]'));

  // check for checkTruncation
  containers.forEach((container) => {
    checkTruncation(container);
  });

  // toggler
  togglers.forEach((toggler) => {
    toggler.addEventListener('click', () => {
      const id = toggler.dataset.truncateToggle;
      const container = document.getElementById(id);

      if (toggler.getAttribute('aria-pressed') === 'true') {
        revertcheckTruncation(container);
      } else {
        checkTruncation(container);
      }
    });
  });
}



// WEBPACK FOOTER //
// ./assets/js/components/truncate-text.js